import type { DialogueDefinition } from '../../domain/types';
import { h01Matched, h01NotCollected } from '../scenes/raadhustorvet';

export const h01HostDialogue: DialogueDefinition = {
  id: 'h01-host',
  startNodeId: 'welcome',
  fictionLabel: 'Fiktiv torvedag i udflugtsbogen.',
  nodes: [
    {
      id: 'welcome',
      speaker: 'Torveværten',
      text: 'Velkommen! Vi vil samle byen til et fjordbal i Skyttehushaven. Men først skal folk hjælpe hinanden. Vil du sætte de fire symbolkort ved de rigtige erhverv?',
      choices: [
        { id: 'h01-why', text: 'Hvad har symbolerne med festen at gøre?', nextNodeId: 'why' },
        { id: 'h01-how', text: 'Hvordan gør jeg?', nextNodeId: 'how' },
        { id: 'h01-hint', text: 'Giv mig et spor.', nextNodeId: 'hint' },
        {
          id: 'h01-ready',
          text: 'De fire kort passer nu.',
          conditions: [...h01Matched, h01NotCollected],
          nextNodeId: 'ready',
        },
        { id: 'h01-leave', text: 'Jeg ser på bordet.', nextNodeId: 'goodbye' },
      ],
    },
    {
      id: 'why',
      speaker: 'Torveværten',
      text: 'Landmanden dyrker kornet, købmanden handler med det, håndværkeren bygger, og industriens maskiner arbejder. Alle kan bidrage. Din første tur går til Den Smidtske Gård efter korn.',
      nextNodeId: 'welcome',
    },
    {
      id: 'how',
      speaker: 'Torveværten',
      text: 'Klik på et symbolkort på bordet. Vælg “Læg ved” det erhverv, du mener passer. Du kan også vælge “Se på” for at få et spor. Når alle fire passer, kan du tage sækken ved boden.',
      nextNodeId: 'welcome',
    },
    {
      id: 'hint',
      speaker: 'Torveværten',
      text: 'Tænk på, hvad tingene gør: veje varer, save træ, høste korn og drive maskiner. Et forkert forsøg koster dig ikke noget.',
      nextNodeId: 'welcome',
    },
    {
      id: 'ready',
      speaker: 'Torveværten',
      text: 'Netop! Alle fire erhverv er på plads. Tag den tomme kornsæk fra boden til højre. Mærket viser, hvor din tur fortsætter.',
      end: true,
    },
    {
      id: 'goodbye',
      speaker: 'Torveværten',
      text: 'Jeg er lige her, hvis du får brug for et spor.',
      end: true,
    },
  ],
};

export const h01CompleteDialogue: DialogueDefinition = {
  id: 'h01-complete',
  startNodeId: 'complete',
  fictionLabel: 'Fiktiv spilramme · Det store fjordbal',
  nodes: [
    {
      id: 'complete',
      speaker: 'Torveværten',
      text: 'Tillykke! Den tomme kornsæk er nu din.',
      end: true,
    },
  ],
};
